import Grid from "@mui/material/Grid";
import {Button, Typography} from "@mui/material";
import {Icon} from "@iconify/react";
import Box from "@mui/material/Box";
import React, {useState} from "react";
import services from "../../services";
import CircularProgress from "@mui/material/CircularProgress";
import {Email} from "@mui/icons-material";
import {useDispatch, useSelector} from "react-redux";
import {RootState} from "../../app/store";
import {addNewDevice} from '../../app/features/userSlice'


interface AddNewDevice {
    handleClose : ()=>void
    adminAccess ?  :boolean
    userEmail ?  : string
}

export const AddNewDevice = ({handleClose,adminAccess = false,userEmail} : AddNewDevice) =>{

    const allDevices = useSelector(((state:RootState) => state.user.devices))

    const dispatch = useDispatch()

    const [showAddDeviceModel,setShowAddDeviceModel] = useState<boolean>(false)

    const [loader,setLoader] = useState<boolean>(false)

    const [imei,setImei] = useState('')
    const [alias,setAlias] = useState('')

    const [deviceAddError,setDeviceAddError] = useState('')

    const handleAddDevice = () =>{

        if(!imei.length) {
            setDeviceAddError("IMEI is required")
            return
        }

        setLoader(true)

        if(alias.length>0 && adminAccess){
            services.AddUserDevice({imei:imei,alias:alias,email:userEmail})
                .then(response=>{
                    handleClose()
                }).catch(error=>{
                setLoader(false)
                setDeviceAddError(error.response.data.message)
            })
        }
        else if(imei.length>0 && alias.length>0 && !adminAccess){
            services.AddNewDevice({imei:imei,alias:alias})
                .then(response=>{
                    let newDevices = [...allDevices, {...response.data.device,UserDevices : response.data.UserDevices}]
                    localStorage.setItem('devices',JSON.stringify(newDevices))
                    dispatch(addNewDevice({...response.data.device,UserDevices : response.data.UserDevices}))
                        handleClose()
                }).catch(error=>{
                    setLoader(false)
                setDeviceAddError(error.response.data.message)
            })
        }else{
            setDeviceAddError("Following fields are required")
            setLoader(false)
        }
    }
    return(
        <Box sx={{ flexGrow:1 }}>
            <Grid container rowSpacing={3} spacing={3} sx={{width:{xs:300,lg:500}}} justifyContent={"center"}>
                <Grid item md={7}>
                    <Typography fontSize={25} fontWeight={400} color={"#081735"}>
                        {"Add New Device"}
                    </Typography>
                    <Typography fontSize={14} fontWeight={400} color={"red"}>
                        {deviceAddError}
                    </Typography>
                </Grid>
                {
                    adminAccess ?
                        <Grid item md={7}>
                            <Typography fontSize={14} fontWeight={400} color={"#081735"}>
                                Email
                            </Typography>
                            <input value={userEmail} disabled={true} className={"edit-profile-inputs"} name={"email"} />
                        </Grid>:''
                }
                <Grid item md={7}>
                    <Typography fontSize={14} fontWeight={400} color={"#081735"}>
                        Alias
                    </Typography>
                    <input value={alias} className={"edit-profile-inputs"} name="alias" onChange={(e)=>setAlias(e.target.value)} />
                </Grid>
                <Grid item md={7}>
                    <Typography fontSize={14} fontWeight={400} color={"#081735"}>
                        IMEI
                    </Typography>
                    <input value={imei} className={"edit-profile-inputs"} name={"imei"} onChange={(e)=>setImei(e.target.value)} />
                </Grid>
                <Grid item md={7} display={"flex"} alignItems={"center"}>
                    <Button
                        onClick={handleAddDevice}
                        variant="contained"
                        className = 'button-hover'
                        sx={{
                            borderRadius:"16px",
                            background:"#E7FAFF",
                            textTransform:"none",
                            color:"#089BAB",
                            width:"100%",
                            fontWeight:700,
                            boxShadow:"none",
                            fontSize : "16px",
                            "&:hover": {
                                //you want this to be the same as the backgroundColor above
                                backgroundColor: "#E7FAFF"
                            }
                        }}> <Icon icon="carbon:add-filled" color="#089BAB" /> &nbsp; Add device
                        <CircularProgress sx={{position:"relative",left:"40px",color:"#089BAB",display:loader?" ":"none"}} size={25} thickness={6}/>
                    </Button>
                </Grid>
            </Grid>
        </Box>
    )
}